import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
    statusCode: number;
    message?: string;
    data?: any;
};
export const ratingAPI = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        getRatingList: builder.query<
            CommonResponse,
            { page?: number; limit?: number; search?: string }
        >({
            query: (params) => {
                const newParams: any = { ...params };
                if (!newParams.search) delete newParams.search;
                return {
                    url: END_POINTS.ratingList,
                    method: "GET",
                    params: newParams,
                }
            },
        }),
        replyRating: builder.mutation<CommonResponse, { id: string, body: any }>({
            query: ({ id, body }) => ({
                url: `${END_POINTS.ratingReply}/${id}`,
                method: "PUT",
                body,
            }),
        }),

    }),
});
export const {
    useLazyGetRatingListQuery,
    useReplyRatingMutation,
} = ratingAPI;
